import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { InterventionDTO } from "../services/dto/intervention.dto";
import { mapper } from "../tools/mapping/mapper";
import { EInterventionStatus } from "./enums/intervention-status";
import { User } from "./user";
import { Zone } from "./zone";
import { Generateur } from "./Dialyse/generateur";
import { Endoscope } from "./Endoscope/endoscope";
import { BaseDOM } from "./base.dom";
import { Appareil } from "./Qualif/appareil";

export class Intervention extends BaseDOM<Intervention> {

    /** ID SERVER */
    @AutoMap()
    Code!: string;
    @AutoMap()
    NomChantier!: string
    @AutoMap()
    Status!: EInterventionStatus;
    @AutoMap()
    IsLastMinute: boolean = false;
    @AutoMap()
    PlannedDate!: Temporal.PlainDate;

    @AutoMap()
    AdresseChantier: string = '';

    @AutoMap()
    Sampler: User = new User();

    // @AutoMap()
    // Biocollecteur: Appareil = new Appareil()
    // @AutoMap()
    // ApplicateurContact: Appareil = new Appareil()
    // @AutoMap()
    // Compteur: Appareil = new Appareil()
    // @AutoMap()
    // Multimetre: Appareil = new Appareil()

    @AutoMap(() => [Zone])
    ZoneList: Zone[] = [];

    @AutoMap(() => [Generateur])
    GenerateurDialyseList: Generateur[] = [];
    @AutoMap(() => [Endoscope])
    EndoscopeList: Endoscope[] = [];

    static mapFromJSON(json: InterventionDTO): Intervention {
        let int = new Intervention;

        int = mapper.map(json, InterventionDTO, Intervention);
        return int;
    }
}